<template>
  <div
    class="h-full bg-curious-blue-100 px-5 py-2 text-gray-600 text-sm w-full"
    v-if="showRecipientInfo"
  >
    <div class="flex h-full">
      <span class="font-semibold flex items-center truncate"
        >To: &nbsp;
        <span class="font-thin">{{ emailPreviewList }}</span>
      </span>
    </div>
    <div class="flex">
      <span class="font-semibold"
        >From: <span class="font-thin"> {{ fromAddress }}</span></span
      >
    </div>
    <div class="flex">
      <span class="font-semibold"
        >{{ `${$t('common.subject')}` }}
        <span class="font-thin"> {{ subjectLine }}</span></span
      >
    </div>
  </div>
  <div
    class="h-full w-full flex flex-1 justify-center items-center bg-gray-100 pb-10"
  >
    <div class="w-full h-full mt-3 device-preview">
      <UITabs type="segment">
        <UITabPane name="macbook" tab="Macbook">
          <template v-slot:tab>
            <div class="space-x-1 flex items-center justify-center">
              <Monitor03Icon class="w-5 h-5 mr-1" />
              <UITextMdMedium>{{ $t('common.desktop') }}</UITextMdMedium>
            </div>
          </template>
          <Devices :device="'macbook'" :html="previewHtml" />
        </UITabPane>
        <UITabPane name="ipad" tab="Ipad">
          <template v-slot:tab>
            <div class="space-x-1.5 flex items-center justify-center">
              <Tablet01Icon class="w-5 h-5 mr-1" />
              <UITextMdMedium>{{ $t('common.tablet') }}</UITextMdMedium>
            </div>
          </template>
          <Devices :device="'ipad'" :html="previewHtml" />
        </UITabPane>
        <UITabPane name="iphone-x" tab="Iphone-x">
          <template v-slot:tab>
            <div class="space-x-1.5 flex items-center justify-center">
              <Phone02Icon class="w-5 h-5 mr-1" />
              <UITextMdMedium>{{ $t('common.mobile') }}</UITextMdMedium>
            </div>
          </template>
          <Devices :device="'iphone-x'" :html="previewHtml" />
        </UITabPane>
      </UITabs>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import { UILoading, UIIcon, UISpinner } from '@gohighlevel/ghl-canvas'
import {
  Monitor03Icon,
  Tablet01Icon,
  Phone02Icon,
} from '@gohighlevel/ghl-icons/24/outline'
import {
  UITabs,
  UITabPane,
  UIContentWrap,
  UITextMdMedium,
  UITextSmMedium,
} from '@gohighlevel/ghl-ui'
import Devices from './Devices.vue'
import '../../assets/devices.min.css'

const props = defineProps({
  fromAddress: {
    type: String,
    required: false,
    default: '',
  },
  subjectLine: {
    type: String,
    required: false,
    default: '',
  },
  previewHtml: {
    type: String,
    required: true,
  },
  contacts: {
    type: Array,
    required: false,
  },
  showRecipientInfo: {
    type: Boolean,
    required: false,
    default: false,
  },
})

const emailPreviewList = computed(() => {
  let contacts = [] as Array<string>
  if (props.contacts) {
    contacts = JSON.parse(JSON.stringify(props.contacts))
    return contacts
      .splice(0, 3)
      .map((x: any) => x.email)
      .join(', ')
  }
  return contacts
})

const selectedDevice = ref('macbook')
</script>

<style lang="scss">
.device-preview {
  .n-tabs {
    height: 100%;
  }
  .n-tabs-tab {
    padding: 6px !important;
  }
  .n-tabs .n-tabs-nav {
    width: 27%;
    transform: translateX(-50%);
    background-color: #fff;
    border: 1px solid lightgrey;
    border-radius: 7px;
    position: relative;
    top: 0px;
    left: calc(50%);
    min-width: 275px;
  }

  .n-tabs .n-tabs-rail {
    background-color: transparent;
    padding: 0;
  }

  .n-tabs .n-tabs-rail .n-tabs-tab-wrapper .n-tabs-tab.n-tabs-tab--active {
    background-color: #2970ff;
    color: #fff;
    /* border-radius: 10px; */
  }
  .n-tabs .n-tab-pane {
    padding-top: 12px;
    height: calc(100% - 50px);
  }

  .n-tabs-tab-wrapper:nth-child(2) .n-tabs-tab--active {
    border-radius: 7px 0 0 7px !important;
  }
  .n-tabs-tab-wrapper:nth-child(3) .n-tabs-tab--active {
    border-radius: 0 !important;
  }
  .n-tabs-tab-wrapper:nth-child(4) .n-tabs-tab--active {
    border-radius: 0 7px 7px 0 !important;
  }
  .n-tabs-tab-wrapper:nth-child(3) {
    border-left: 1px solid lightgrey;
  }
  .n-tabs-tab-wrapper:nth-child(4) {
    border-left: 1px solid lightgrey;
  }
  .n-tabs .n-tabs-rail .n-tabs-capsule {
    background-color: #2970ff;
    color: #fff;
  }
}
</style>
